import styled from 'styled-components';

const StyledSideMenuSwitch = styled.button`
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.primary} !important;
  color: ${(props) => props.theme.colors.text.primary};
  width: 40px;
  height: 40px;
  min-height: 40px;
  min-width: 40px;
  font-family: 'Material Icons Outlined' !important;
  font-size: 20px;
  font-weight: 300 !important;
  border: none;
  margin-left: 10px;

  &:hover {
    color: ${(props) => props.theme.colors.text.detail};
  }

  // Media Queries
  @media (min-width: ${(props) => props.theme.screenSizeBreakpoints.xs}) {
    margin-left: 0px;
  }

  // Media Queries
  @media (min-width: ${(props) => props.theme.screenSizeBreakpoints.m}) {
    display: none;
  }
  
`;

export { StyledSideMenuSwitch };
